<script setup>
import NRFeedback from "@/Components/NR-Feedback.vue";
</script>

<template>
    <v-layout class="rounded rounded-md">
        <v-app-bar flat>
            <v-row class="d-flex justify-center bg-cadet">
                <v-col cols="auto">
                    <img
                        src="/static/images/foster_hub_login.png"
                        alt="Application Logo"
                        class="pa-7"
                        height="104"
                    />
                </v-col>
            </v-row>
        </v-app-bar>
        <v-main
            style="min-height: 480px;"
        >
            <v-container class="v-container">
                <v-row class="bg-white">
                    <v-col cols="12" class="d-flex justify-center mt-16 pb-0 mb-0">
                        <NR-Feedback class="w-33"/>
                    </v-col>
                    <v-col cols="12">
                        <div class="d-flex justify-center">
                            <slot/>
                        </div>
                    </v-col>
                </v-row>
            </v-container>
        </v-main>
    </v-layout>
</template>

<style>
body {
    background-color: rgb(var(--v-theme-cadet));
}

.v-container {
    min-width: 100%;
    padding: 0 !important;
}
</style>
